import { DeviceType } from 'src/types/DeviceType';

export interface ProjectTargets {
  properties: number;
  devices: number;
  gateways: number;
}

export interface ProjectOrg {
  /** Stable switcher key, e.g. 'nkdc'. */
  key: string;
  name: string;
  /** Short name for file names, e.g. 'NKDC'. Falls back to `name`. */
  shortName?: string;
  /** null = placeholder ("not set up"): nothing is fetched. */
  organisationId: string | null;
  /** Display only, e.g. 'Phase 1'. */
  phase?: string;
  targets?: ProjectTargets;
  /**
   * When set, property, device and alert metrics are restricted to these properties.
   * Gateways stay organisation-wide (spec D7).
   */
  propertyIds?: string[];
}

export interface ProjectConfig {
  /** e.g. 'mouldwatch-2026'. Also the tab key and the react-query key prefix. */
  key: string;
  label: string;
  /** ISO date (YYYY-MM-DD): alarm-history window start and timeline origin. */
  startDate: string;
  deviceType: DeviceType;
  orgs: ProjectOrg[];
}

/**
 * Everything the Projects page calls needs: device search (SEARCH_DEVICE), assignments
 * (SEARCH_DEVICEASSIGNMENT), mould alarm history (SEARCH_ALARM_HISTORY), bulk last-seen
 * (SEARCH_DEVICE_SAMPLES) and gateway seen-devices (GET_DEVICE_BY_ID). Shared by the route
 * guard and the sidebar so the link and the route cannot disagree.
 */
export const PROJECTS_PAGE_PERMISSIONS: string[] = [
  'SEARCH_DEVICE',
  'SEARCH_DEVICEASSIGNMENT',
  'SEARCH_ALARM_HISTORY',
  'SEARCH_DEVICE_SAMPLES',
  'GET_DEVICE_BY_ID',
];

export const MOULDWATCH_2026: ProjectConfig = {
  key: 'mouldwatch-2026',
  label: 'MouldWatch 2026',
  startDate: '2026-08-25',
  deviceType: DeviceType.MILESIGHT_AM102,
  orgs: [
    {
      key: 'nkdc',
      name: 'North Kesteven District Council',
      shortName: 'NKDC',
      organisationId: '29c44f98-baad-43a1-8204-66103cfdfe6b',
      phase: 'Phase 1',
      targets: { properties: 750, devices: 2250, gateways: 21 },
    },
    {
      key: 'town-and-country',
      name: 'Town & Country Housing',
      shortName: 'TCH',
      organisationId: null,
    },
  ],
};

export const PROJECTS: ProjectConfig[] = [MOULDWATCH_2026];
